import { render } from "./xAppsXCargoPage.vue?vue&type=template&id=d0e2da58&scoped=true"
import script from "./xAppsXCargoPage.vue?vue&type=script&lang=js"
export * from "./xAppsXCargoPage.vue?vue&type=script&lang=js"

import "./xAppsXCargoPage.vue?vue&type=style&index=0&id=d0e2da58&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0e2da58"]])

export default __exports__